import { httpStatus } from './compat'
import { readSession } from './session'

let lastReport = ''
let lastAt = 0

/** TV-də konsol yoxdur: yalnız kod və cihaz məlumatı yazılır, media URL/token yox. */
export function reportMediaError(stage: string, code: number, contentId?: string | null): void {
  const key = stage + ':' + code + ':' + (contentId || '')
  const now = Date.now()
  if (key === lastReport && now - lastAt < 60000) return
  lastReport = key
  lastAt = now
  const session = readSession()
  const token = session ? session.accessToken : undefined
  void httpStatus('/api/client-errors', {
    method: 'POST',
    timeoutMs: 5000,
    headers: token ? { Authorization: 'Bearer ' + token } : {},
    body: JSON.stringify({
      source: 'tv',
      code: 'Client.Media',
      message: stage + ' code=' + code + ' device=' + navigator.userAgent.slice(0, 400),
      path: '/player/' + (contentId || 'trailer'),
    }),
  }).catch(() => undefined)
}
